import bankStatementsStyles from './BankStatements.module.css';
import { TOfferDataRequirement } from '../../../../../types';
import DocumentRequirement from '../../../DocumentRequirement/DocumentRequirement';

type TProps = {
  title: string;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
const ManualUploadUK = ({ status, isSubmitted }: TProps) => {
  return (
    <DocumentRequirement
      className={bankStatementsStyles.documentRequirement}
      documentType="bank statement"
      isSubmitted={isSubmitted}
      status={status}
    >
      <ul>
        <li>
          You can download these from your online banking (
          <a
            href="https://assets.ctfassets.net/835lsoe3tdrh/5xeVjM3ENgzeYwopDbyFs8/9b7c1f2a481fa7aef8006a5caa165b81/iwoca_bank_statement_pdf_download_guide.pdf"
            target="_blank"
            rel="noreferrer"
          >
            See instructions
          </a>
          )
        </li>
        <li>Files must be PDF or JPG, JPEG, PNG and no more than 2GB.</li>
        <li>
          These should be for the account(s) where the majority of your business
          revenue is generated.
        </li>
        <li>
          Please ensure the statements display the business name, sort code,
          account number and the account balance.
        </li>
      </ul>
    </DocumentRequirement>
  );
};

export default ManualUploadUK;
